import React, { Component } from "react"
import { COLORS } from "../../../utils/Colors"
import ZinterviewLogo from "./ZinterviewLogo"

export default class ZinterviewAbout extends Component {
  render() {
    return (
      <div className="row" style={styles.container}>
        <div className="col-12" style={styles.subContainer}>
          <div className="col-12 col-md-10 offset-md-1">
            <div style={styles.headerRow}>
                <ZinterviewLogo height={42} />
                <div style={styles.headingRow}>
                    <span style={styles.badge}>Our New Product</span>
                </div>
            </div>
            <div>
              <p style={styles.text}>
                Zinterview is a brand owned and operated by <span style={{ color: COLORS.HIGHlIGHTED_TEXT }}>Tigersheet Online DB Private Limited</span>, 
                a company incorporated in 2014 and based in Hyderabad, India. Tigersheet is part of the <span style={{ color: COLORS.HIGHlIGHTED_TEXT }}>Riktam Group of Companies</span>,
                a technology-driven group anchored by <span style={{ color: COLORS.HIGHlIGHTED_TEXT }}>Riktam Technology Consulting</span>, 
                a trusted name in IT consulting for over 15 years. With a strong legacy of delivering high-quality digital solutions across industries, 
                Riktam brings the experience, stability, and innovation that power Zinterview's mission to transform the way companies hire.
              </p>

              <div style={styles.ctaWrapper}>
                <a
                  href="https://zinterview.ai"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.cta}
                >
                  Explore Zinterview →
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const styles = {
  container: {
    backgroundColor: COLORS.PRIMARY_COLOR,
  },

  subContainer: {
    backgroundColor: COLORS.INQUIRY_BACKGROUND,
    paddingTop: 60,
    paddingBottom: 50,
  },

  headerRow: {
    display: "flex",
    alignItems: "center",
    marginBottom: 26,
  },

  logo: {
    height: 44,
    marginRight: 16,
  },

  headingRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginLeft: 10
  },

  heading: {
    fontSize: 36,
    fontFamily: "SFProHvy",
    color: COLORS.THEME_COLOR,
  },

  badge: {
    fontSize: 11,
    fontFamily: "SFProBold",
    letterSpacing: 1,
    padding: "5px 10px",
    borderRadius: 14,
    color: COLORS.THEME_COLOR,
    backgroundColor: "rgba(70, 100, 255, 0.12)",
    whiteSpace: "nowrap",
  },

  text: {
    fontFamily: "SFProSmBold",
    fontSize: 16,
    color: COLORS.CONTACT_DETAILS_HEADING,
    lineHeight: 1.6,
    marginBottom: 18,
  },

  ctaWrapper: {
    marginTop: 26,
  },

  cta: {
    display: "inline-block",
    padding: "10px 22px",
    fontSize: 14,
    fontFamily: "SFProBold",
    color: "#ffffff",
    backgroundColor: COLORS.THEME_COLOR,
    borderRadius: 6,
    textDecoration: "none",
  },
}
